<template>
	<div id="editor">
		<div v-if="working" class="d-flex justify-content-center align-items-center" style="min-height:300px">
			<spinner size="huge" message="Updating..."></spinner>
		</div>
		<div v-if="!working">
			<form v-on:submit.prevent="transmitForm">
				<div class="container">
					<div class="head row">
						<div class="col col-sm-3" style="text-align:left">
							<i class="pseudobutton mdi mdi-arrow-right-bold-circle mdi-24px" @click="$emit('closeEditor')"><span style="">Back</span></i>
						</div>
						<div class="col col-sm-9">
							<h3>Add new Site</h3>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="s_domain">Domain</label>
				    <div class="col-sm-9">
							<input type="text" class="form-control form-control-sm"  name="s_domain" v-model="site.M_DOMAIN" id="s_domain"  required/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-12 col-form-label" for="note">Note</label>
						<div class="col-sm-12">
							<input type="text" class="form-control form-control-sm"  name="s_note" v-model="site.M_SHORTNOTE" id="s_note"/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="s_domain">Provider</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="s_url" v-model="site.M_PROVIDER" id="s_provider"/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="s_googlelang">Registry</label>
						<div class="col-sm-9">
							<b-form-select size="sm" v-model="site.M_RID" :options="registries" placeholder="Choose one" />
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="s_googleregion">IP</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="s_baseip" v-model="site.M_BASEIP" id="s_baseip"/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="s_domain">System User</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="ssh_user" v-model="site.M_SSH_USER" id="ssh_user"/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="ssh_password">System Password</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="ssh_password" v-model="site.M_SSH_PWD" id="ssh_password"/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="s_domain">FTP User</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="ftp_user" v-model="site.M_FTP_USER" id="ftp_user"/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="ftp_password">FTP Password</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="ftp_password" v-model="site.M_FTP_PWD" id="ftp_password"/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="s_domain">WP Base Url</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="wp_user" v-model="site.M_WP_URL" id="wp_baseurl"/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="s_domain">WP User</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="wp_user" v-model="site.M_WP_USER" id="wp_user"/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="wp_password">WP Password</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="wp_password" v-model="site.M_WP_PWD" id="wp_password"/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="s_domain">Panel Base Url</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="panel_address" v-model="site.M_PANEL_ADDRESS" id="panel_address"/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="s_domain">Panel User</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="panel_user" v-model="site.M_PANEL_USER" id="panel_user"/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="panel_password">Panel Password</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="panel_password" v-model="site.M_PANEL_PWD" id="panel_password"/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-12 col-form-label" for="wp_password">Remarks</label>
						<div class="col-sm-12">
							<textarea class="form-control form-control-sm" style="height:150px" v-model="site.M_OTHER" name="M_OTHER" id="M_OTHER"></textarea>
						</div>
					</div>
					<div class="row">
						<div class="col form-group" style="text-align:center">
							<button class="btn btn-success" type="submit">Change</button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</template><script>
import Spinner from 'vue-simple-spinner'

export default {

	components: {
		Spinner
	},
	props: ['site', 'servers', 'working', 'registries'],

	data() {
		return {
			renewclass: '',
		}
	},
	created: function() {
	},
  methods: {
		transmitForm() {
			var fields = [ 'M_RID', 'M_DOMAIN',
					'M_PROVIDER', 'M_BASEIP', 'M_FTP_USER',
					'M_FTP_PWD', 'M_WP_USER', 'M_WP_PWD',
					'M_WP_URL', 'M_SSH_USER', 'M_SSH_PWD', 
					'M_PANEL_ADDRESS', 'M_PANEL_USER', 'M_PANEL_PWD', 'M_OTHER', 'M_SHORTNOTE' ]
			let transfer = {}
			for(var i = 0;i < fields.length;i++) {
				transfer[fields[i]] = this.site[fields[i]]
			}
			this.$emit('insertItem', transfer)
		},
		makePassword() {
			let chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
	    let result = '';
			for (let i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
			this.site.M_FTP_PWD = result
			this.site.M_WP_PWD = result
		}
  }
}
</script>
